import Vue from 'vue';
import Router from 'vue-router';
import store from './store.js';
import Sucursal from './modules/restaurant/models/Sucursal.js';

import Login from './components/Login.vue';
import Secure from './components/Secure.vue';
import Register from './components/Register.vue';

import PrintTicket from './views/Printer/Ticket.vue'
import PrintTicketV2 from './views/Printer/TicketV2.vue'
import PrintComanda from './views/Printer/Comanda.vue'

// views Restaurant
import ResAlimentosEdit from './views/Restaurant/AlimentosEdit'
import ResAlimentosList from './views/Restaurant/AlimentosList'
import ResClientesEdit from './views/Restaurant/ClientesEdit'
import ResClientesList from './views/Restaurant/ClientesList'
import ResDomiciliosEdit from './views/Restaurant/DomiciliosEdit'
import ResDomiciliosList from './views/Restaurant/DomiciliosList'
import ResHerisOrdenesEdit from './views/Restaurant/Heris/HerisOrdenesEdit'
import ResRepartidoresEdit from './views/Restaurant/RepartidoresEdit'
import ResRepartidoresList from './views/Restaurant/RepartidoresList'
import ResEstadisticas from './views/Restaurant/Estadisticas.vue';
import ResHerisOrdenesGrid from './views/Restaurant/OrdenesGrid.vue';
import ResConfiguracion from './views/Restaurant/Configuracion.vue';
import ResCheckout from  './views/Restaurant/Checkout.vue';
import ResHistorial from  './views/Restaurant/OrdenesHistorialList.vue';
import ResHistorialEdit from './views/Restaurant/OrdenesHistorialEdit.vue';

Vue.use(Router);

const base = process.env.VUE_APP_BASE_URL;

const router = new Router({
  mode: 'history',
  routes: [

    // Impresion
    {
      path: base+'/ticket',
      name: 'PrintTicket',
      component: PrintTicket,
      props:true,
    },
    {
      path: base+'/ticketv2/:ordenId',
      name: 'PrintTicketV2',
      component: PrintTicketV2,
      props:true,
    },
    {
      path: base+'/comanda/:tipo/:ordenId',
      name: 'PrintComanda',
      component: PrintComanda,
      props: true,
    },

    //Control de Usuarios
    {
      path: base+'/login',
      name: 'login',
      component: Login,
    },
    {
      path: base+'/register',
      name: 'register',
      component: Register,
    },
    {
      path: base+'/secure',
      name: 'secure',
      component: Secure,
      meta: {
        requiresAuth: true,
      },
    },
    //Fin Control de Usuarios

    // Restaurant
    {
      name: 'ResEstadisticas',
      path: base+'/estadisticas',
      component:ResEstadisticas,
    }, 
    {
      name: 'ResConfiguracion',
      path: base+'/configuracion',
      component:ResConfiguracion,
    }, 

    //Ordenes
    {
      name: 'ResHerisOrdenesGrid',
      path: base+'/inicio',
      component:ResHerisOrdenesGrid,
    },  
    {
      name: 'ResHerisOrdenesEdit',
      path: base+'/orden/:ordenId',
      component: ResHerisOrdenesEdit,
      props: true,
    },
    {
      name: 'ResHerisOrdenesCreate',
      path: base+'/orden/',
      component: ResHerisOrdenesEdit,
      props: true,
    },
    {
      name: 'ResCheckout',
      path: base+'/checkout/:ordenId',
      component: ResCheckout,
      props: true
    },
    {
      name: 'ResOrdenesEdit',
      path: base+'/historialOrdenes/edit/',
      component: ResHistorialEdit,
      props: true
    },
    {
      name: 'ResOrdenesHistorial',
      path: base+'/historialOrdenes',
      component: ResHistorial,
      props: true
    },

    //Alimentos
    {
      name: 'ResAlimentosEdit',
      path: base+'/alimento/:alimentoId',
      props: true,
      component: ResAlimentosEdit,
    },
    {
      name: 'ResAlimentosCreate',
      path: base+'/alimento',
      component: ResAlimentosEdit,
    },
    {
      name: 'ResAlimentosList',
      path: base+'/alimentos',
      component: ResAlimentosList,
    },
    
    //Clientes
    {
      name: 'ResClientesEdit',
      path: base+'/cliente',
      component: ResClientesEdit,
    },
    {
      name: 'ResClientesList',
      path: base+'/clientes',
      component: ResClientesList,
    },
    {
      name: 'ResDomiciliosEdit',
      path: base+'/domicilio',
      component: ResDomiciliosEdit,
    },
    {
      name: 'ResDomiciliosList',
      path: base+'/domicilios',
      component: ResDomiciliosList,
    },
    
    //Repartidores
    {
      name: 'ResRepartidoresEdit',
      path: base+'/repartidor/:repartidorId',
      component: ResRepartidoresEdit,
      props: true,
    },
    {
      name: 'ResRepartidoresCreate',
      path: base+'/repartidor',
      component: ResRepartidoresEdit,
    },
    {
      name: 'ResRepartidoresList',
      path: base+'/repartidores',
      component: ResRepartidoresList,
    },
    {
      path: '*',
      component: ResConfiguracion
    }
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // console.log("isloogetin", store.getters.isLoggedIn)
    if (Sucursal.getSucursal() != null) {
      next();
      return;
    }
    next('/login');
  } else {
    next();
  }
});

export default router;
